module.exports = __webpack_public_path__ + "static/media/19ESCAP9.95ec234d.jpg";